import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import {
	PageIncludeByIdQuery,
	type PageIncludeByIdQuery$data,
	type PageIncludeByIdQuery$variables,
} from '@confluence/page-include-macro/entry-points/PageIncludeByIdQuery.ts';
import {
	PageIncludeByTitleQuery,
	type PageIncludeByTitleQuery$data,
	type PageIncludeByTitleQuery$variables,
} from '@confluence/page-include-macro/entry-points/PageIncludeByTitleQuery.ts';
import {
	getPageIncludeQueryTarget,
	parseMacroTarget,
} from '@confluence/page-include-macro/entry-points/pageIncludeMacroParams.ts';

import type {
	MacroContentNode,
	MacroPreloadContext,
	MacroPreloadHandler,
} from '../preloadMacroData.ts';

const preloadById = (variables: PageIncludeByIdQuery$variables) =>
	query<PageIncludeByIdQuery$data, PageIncludeByIdQuery$variables>({
		query: PageIncludeByIdQuery,
		variables,
		context: { single: true },
	});

const preloadByTitle = (variables: PageIncludeByTitleQuery$variables) =>
	query<PageIncludeByTitleQuery$data, PageIncludeByTitleQuery$variables>({
		query: PageIncludeByTitleQuery,
		variables,
		context: { single: true },
	});

export const pageIncludePreloadHandler: MacroPreloadHandler = {
	extensionKey: 'include',

	preload: async (node: MacroContentNode, context: MacroPreloadContext): Promise<void> => {
		const parsedTarget = parseMacroTarget(node.attrs?.parameters?.macroParams);
		const queryTarget = getPageIncludeQueryTarget(parsedTarget, context.spaceKey);

		if (queryTarget.kind === 'by-id') {
			await preloadById(queryTarget.variables);
			return;
		}

		if (queryTarget.kind === 'by-title') {
			await preloadByTitle(queryTarget.variables);
		}
	},
};
